import { useTranslation } from "react-i18next";

export default function Kerngegevens() {
  const { t } = useTranslation("wie-zijn-wij");
  const items = t("kerngegevens.items", { returnObjects: true }) as Array<{
    stat: string;
    label: string;
  }>;

  return (
    <section className="bg-brand-cream py-16 md:py-24 w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight text-center mb-10 md:mb-14">
          {t("kerngegevens.h2")}
        </h2>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {items.map((item, i) => (
            <div
              key={i}
              className="bg-white rounded-xl p-6 md:p-8 border-2 border-brand-yellow text-center"
            >
              <p className="font-geist-mono font-bold text-3xl md:text-4xl text-brand-text mb-2 md:mb-3">
                {item.stat}
              </p>
              <p className="font-geist text-sm md:text-base text-brand-text/70">
                {item.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}